(function () {
  "use strict";

  const DAY_KEYS = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  function bindLightbox(page) {
    const lightbox = page.querySelector("#lightbox");
    const image = page.querySelector("#lightbox-image");
    const caption = page.querySelector("#lightbox-caption");
    const closeBtn = page.querySelector("#lightbox-close");
    const dialog = lightbox ? lightbox.querySelector(".lightbox__dialog") : null;
    const gallery = page.querySelector("#photo-gallery");
    if (!lightbox || !image || !gallery) return;

    let lastFocus = null;
    const items = Array.from(gallery.querySelectorAll(".gallery__item"));

    function openAt(index) {
      const btn = items[index];
      if (!btn) return;
      const img = btn.querySelector("img");
      const cap = btn.querySelector(".gallery__caption");
      if (!img) return;
      lastFocus = document.activeElement;
      image.src = img.currentSrc || img.src;
      image.alt = img.alt || "";
      if (caption) caption.textContent = cap ? cap.textContent : "";
      lightbox.hidden = false;
      lightbox.classList.add("is-open");
      document.body.style.overflow = "hidden";
      if (dialog) dialog.focus();
    }

    function close() {
      lightbox.classList.remove("is-open");
      lightbox.hidden = true;
      image.removeAttribute("src");
      image.alt = "";
      document.body.style.overflow = "";
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }

    gallery.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-gallery-index]");
      if (!btn) return;
      openAt(Number(btn.getAttribute("data-gallery-index")));
    });

    closeBtn?.addEventListener("click", close);
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) close();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && lightbox.classList.contains("is-open")) close();
    });
  }

  function readJson(page, id) {
    const el = page.querySelector("#" + id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  function brusselsNow() {
    try {
      const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Brussels",
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        hourCycle: "h23",
      }).formatToParts(new Date());
      const map = {};
      parts.forEach((p) => {
        if (p.type !== "literal") map[p.type] = p.value;
      });
      const weekdayMap = {
        Sun: "sunday",
        Mon: "monday",
        Tue: "tuesday",
        Wed: "wednesday",
        Thu: "thursday",
        Fri: "friday",
        Sat: "saturday",
      };
      const day = weekdayMap[map.weekday];
      if (!day || map.hour == null || map.minute == null) return null;
      const minutes = Number(map.hour) * 60 + Number(map.minute);
      if (Number.isNaN(minutes)) return null;
      return { day, minutes };
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  function toMinutes(hhmm) {
    const [h, m] = String(hhmm).split(":").map(Number);
    return h * 60 + m;
  }

  function fill(template, vars) {
    return String(template).replace(/\{(\w+)\}/g, (_, key) =>
      vars[key] != null ? String(vars[key]) : ""
    );
  }

  function nextOpen(schedule, fromDayIndex) {
    for (let offset = 1; offset <= 7; offset += 1) {
      const idx = (fromDayIndex + offset) % 7;
      const key = DAY_KEYS[idx];
      const entry = schedule[key];
      if (entry && !entry.closed && entry.open) {
        return { day: key, open: entry.open };
      }
    }
    return null;
  }

  function bindHours(page) {
    const data = readJson(page, "store-hours-data");
    const i18n = readJson(page, "hours-i18n");
    if (!data || !i18n || !data.openingHours) return;

    const schedule = data.openingHours;
    const now = brusselsNow();
    const rows = page.querySelectorAll("[data-hours-body] tr[data-day]");
    const statusEl = page.querySelector("[data-hours-status]");
    const todayEl = page.querySelector("[data-hours-today]");
    const locationSummary = page.querySelector("[data-hours-location-summary]");

    if (now) {
      rows.forEach((row) => {
        row.classList.toggle("is-today", row.getAttribute("data-day") === now.day);
      });
    }

    if (!now) return;

    const today = schedule[now.day];
    const dayIndex = DAY_KEYS.indexOf(now.day);

    if (todayEl) {
      if (!today || today.closed) {
        todayEl.textContent = i18n.status.todayClosed;
      } else {
        todayEl.textContent = fill(i18n.status.todayOpen, {
          open: today.open,
          close: today.close,
        });
      }
    }

    if (locationSummary && today && !today.closed) {
      locationSummary.textContent = fill(i18n.status.todayOpenLong, {
        open: today.open,
        close: today.close,
      });
    } else if (locationSummary && (!today || today.closed)) {
      locationSummary.textContent = i18n.status.todayClosed;
    }

    if (!statusEl) return;

    let text = i18n.status.closedNow;
    let state = "closed";

    if (today && !today.closed) {
      const openM = toMinutes(today.open);
      const closeM = toMinutes(today.close);
      if (now.minutes >= openM && now.minutes < closeM) {
        text = i18n.status.openNow;
        state = "open";
      } else if (now.minutes < openM) {
        text = fill(i18n.status.opensToday, { time: today.open });
      } else {
        const nxt = nextOpen(schedule, dayIndex);
        if (nxt) {
          text = fill(i18n.status.opensDay, {
            day: i18n.days[nxt.day],
            time: nxt.open,
          });
        }
      }
    } else {
      const nxt = nextOpen(schedule, dayIndex);
      if (nxt) {
        text = fill(i18n.status.opensDay, {
          day: i18n.days[nxt.day],
          time: nxt.open,
        });
      }
    }

    statusEl.hidden = false;
    statusEl.textContent = text;
    statusEl.setAttribute("data-state", state);
    statusEl.setAttribute("role", "status");
  }

  function init() {
    const page = document.querySelector(".muskle-hasselt-page");
    if (!page) return;
    bindLightbox(page);
    bindHours(page);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
